/* eslint-disable @typescript-eslint/naming-convention */
import { CommandClaim } from '@ews/users-management';

export const CreateNote = new CommandClaim('CreateNote');
export const UpdateNote = new CommandClaim('UpdateNote');
export const DeleteNote = new CommandClaim('DeleteNote');

export const CreateAction = new CommandClaim('CreateAction');
export const UpdateAction = new CommandClaim('UpdateAction');
export const DeleteAction = new CommandClaim('DeleteAction');

export const CreateNC = new CommandClaim('CreateNC');
export const UpdateNC = new CommandClaim('UpdateNC');
export const DeleteNC = new CommandClaim('DeleteNC');
